import api from './api';
import * as apiMock from './api-mock';

const useMock = process.env.USE_API_MOCK;

export default useMock ? apiMock : api;
